import { render, staticRenderFns } from "./BuyCard.vue?vue&type=template&id=786cdce2&scoped=true&"
import script from "./BuyCard.vue?vue&type=script&lang=js&"
export * from "./BuyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786cdce2",
  null
  
)

export default component.exports